<template>
    <div class="ads-item">
        <el-image :src="data.filesavepath ? data.filesavepath : ''" class="ads-item_inner" fit="cover" :alt="data.adtitle"></el-image>
        
        <div class="adv-title">
            <p class="time">
                <i class="el-icon-time"></i>
                {{data.fbdate}}
            </p>
            <p class="title">{{data.articletitle}}</p>
            <div class="underline"></div>

            <p class="cont">{{ mainText}} </p>

            <a
            target="_blank"
            :href="`/news/${data.guid}`"
            >
                <el-button size="medium" @click="gotoDetails" class="adv-btn">查看详情</el-button>
            </a>
        </div>
    </div>

</template>

<script>
import { ToText } from '../assets/js/news.js'
export default {
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        props: {
            type: Object,
            default: () => ({
                img: 'filesavepath',
                link: 'linkurl',
                guid: 'adguid',
            }),
        },
        fontSize: {
            type: String,
            default: '14px',
        },
        offset: {
            type: String,
            default: '0px',
        },
    },
    data() {
        return {
            imgUrl:'',
        }
    },
    watch:{ },
    computed: {
        mainText() {
            return ToText(this.data.mainbody)
        }
    },

    methods: {
        gotoDetails() {
            let data = {
                guid: this.data.guid
            }
            this.$emit('getDetails' , data);
        },
    },

};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.ads-item {
    // display: block;
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 20px;

    .ads-item_inner {
        display: inline-block;
        width: 540px;
        height: 330px;
    }

    .adv-title {
        width: 560px;
        margin: 20px 10px 10px 30px;
        color: #333333;
        line-height: 2em;
        // background-color: rgba(0, 0, 0, 0.21);
        .time {
            font-size: 16px;
            display: inline-block;
            margin-bottom: 14px;
            color: #444;
        }
        .title {
            font-size: 22px;
            font-weight: 500;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;

        }
        .underline {
            height: 0;
            border-bottom: 1px solid #d8d8d8;
            margin: 20px 0;
        }
        ::v-deep .cont {
            font-size: 16px;
            // background-color: antiquewhite;
            min-height: 84px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;

        }
        .adv-btn {
            color: white;
            background-color: #8a1f94;
            margin-top: 35px;
            font-size: 12px;
            padding: 10 260px;
        }
        .el-button--medium {
            padding: 10px 22px 11px;
            font-size: 12px;
            border-radius: 4px;
        }
    }
}

.ad-placeholder {
    display: block;
    width: 0;
    height: 0;
}
</style>